"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PRODUCTIVITY = exports.CUSTOMER_SUCCESS = exports.SALES = exports.MARKETING = exports.FINANCE = void 0;
var FINANCE = 'finance';
exports.FINANCE = FINANCE;
var MARKETING = 'marketing';
exports.MARKETING = MARKETING;
var SALES = 'sales';
exports.SALES = SALES;
var CUSTOMER_SUCCESS = 'customer-success';
exports.CUSTOMER_SUCCESS = CUSTOMER_SUCCESS;
var PRODUCTIVITY = 'productivity';
exports.PRODUCTIVITY = PRODUCTIVITY;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/constants/urlSlugs/SuperCategorySlug.js
// module id = 113
// module chunks = 209 210 211 212 213